
export const dzDefaultConfig = () => {
    const defaultconfig = {
        accept: {
            'image/*': [],
            'text/plain': [],
            'text/csv': [], 
            'application/vnd.ms-powerpoint': [],
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': [],
            'application/vnd.ms-excel': [],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
            'application/pdf': [],
            'application/msword': [],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document':[],
        },
        maxFiles: 5,
        maxSize: 5000000
    }

    return defaultconfig;
}